import {
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
  CheckBox as CheckBoxIcon
} from '@material-ui/icons';
import { Virtuoso } from 'react-virtuoso';

const Option = ({ option, onOptionSelected, optionsRenderer: OptionsRenderer, classes }) => {
  const handleClick = () => {
    onOptionSelected({ ...option, checked: !option.checked });
  };
  return (
    <li
      onClick={handleClick}
      className={classes.formControlLabel}
      role="checkbox"
      key={option.value}
      aria-checked={option.checked}>
      <span
        className={`${classes.checkbox_root} ${option.checked ? classes.checkbox_checked : ''}`}>
        {option.checked ? <CheckBoxIcon color="primary" /> : <CheckBoxOutlineBlankIcon />}
      </span>
      <span className={classes.formControlLabelColor}>
        {option.value && OptionsRenderer ? <OptionsRenderer {...option} /> : option.label}
      </span>
    </li>
  );
};

export const OptionsList = ({
  onOptionSelected,
  OptionsRenderer,
  classes,
  options,
  listHeight
}) => {
  const optionLength = options.length;
  const renderOption = (_, option) => (
    <Option
      option={option}
      onOptionSelected={onOptionSelected}
      OptionsRenderer={OptionsRenderer}
      classes={classes}
    />
  );

  return (
    <>
      {optionLength ? (
        <Virtuoso
          className={`${classes.list} customScroll`}
          style={{ height: listHeight }}
          data={options}
          itemContent={renderOption}
        />
      ) : (
        <div className={classes.noOptions}> NO RESULTS </div>
      )}
    </>
  );
};
